import { render, staticRenderFns } from "./SwapIntro.vue?vue&type=template&id=a9126f60&"
import script from "./SwapIntro.vue?vue&type=script&lang=js&"
export * from "./SwapIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports